import { render, staticRenderFns } from "./UserGridManager.vue?vue&type=template&id=537f729b&"
import script from "./UserGridManager.vue?vue&type=script&lang=js&"
export * from "./UserGridManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports